import { FORUMS_BASE_URL } from 'Frontend/constants/endpoint'
import { getAntiforgeryToken } from './general.service'

//Tags
export async function updateForumTag(tagId: string, tagName: string): Promise<Boolean> {
  const token = await getAntiforgeryToken()
  const bodyForumTag = JSON.stringify({
    Name: tagName,
  })
  let response = await fetch(`${FORUMS_BASE_URL}/forumtags/${tagId}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-TOKEN': token.csrfToken,
    },
    body: bodyForumTag,
  })
  const jsonResults = (await response.ok) ?? response.ok
  return jsonResults
}

export async function createForumTag(tagName: string): Promise<Boolean> {
  const token = await getAntiforgeryToken()

  const bodyForumTag = JSON.stringify({
    Name: tagName,
  })

  let response = await fetch(`${FORUMS_BASE_URL}/forumtags`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-TOKEN': token.csrfToken,
    },
    body: bodyForumTag,
  })
  const jsonResults = (await response.ok) ?? response.ok
  return jsonResults
}

export async function deleteForumTag(tagId: string): Promise<Boolean> {
  const token = await getAntiforgeryToken()
  await fetch(`${FORUMS_BASE_URL}/forumtags/${tagId}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-TOKEN': token.csrfToken,
    },
  })
  return true
}
